import HttpService from "@core/services/http/http.service";
import { AuthorBank, PendingCountResponse } from "@app/types/author-bank.type";
import { GetListResponse } from "@app/types";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _AuthorBankService {
  public getList(
    requestParams?: RequestParams,
    signal?: Signal,
    isShowLoading?: boolean
  ) {
    return HttpService.get<GetListResponse<AuthorBank>>("/admin/api/v3/author-bank", {
      queryParams: { ...requestParams },
      signal,
      isShowLoading,
    });
  }

  public getPendingCount() {
    return HttpService.get<PendingCountResponse>("/admin/api/v3/author-bank/pending-count");
  }

  public approve(id: number) {
    return HttpService.patch(`/admin/api/v3/author-bank/${id}/approve`);
  }

  public reject(id: number, reason?: string) {
    return HttpService.patch(`/admin/api/v3/author-bank/${id}/reject`, {
      body: { reason },
    });
  }
}

const AuthorBankService = new _AuthorBankService();

export default AuthorBankService;
